import { useRequest } from 'ahooks';
import { useState, useRef } from 'react';
import { getPolicyTimeline } from '../../../axios/api'

// 全局缓存，避免重复请求
const globalCache = new Map();
const cacheTimeout = 5 * 60 * 1000; // 5分钟缓存

function useGetPolicyTimeline(){
  const [queryArgs, setQueryArgs] = useState({
    policy_title: "",
    policy_id: "",
  })
  
  const cacheKey = useRef('');

  const {  data, loading, run } = useRequest(
    async () => {
      try {
        // 生成缓存key
        const key = `${queryArgs.policy_title}-${queryArgs.policy_id}`;
        cacheKey.current = key;
        
        // 检查缓存
        const cached = globalCache.get(key);
        if (cached && Date.now() - cached.timestamp < cacheTimeout) {
          return cached.data;
        }
        
        // 请求新数据
        const resp = await getPolicyTimeline({
          ...queryArgs
        });
        
        // 缓存结果
        const result = resp?.data;
        if (result) {
          globalCache.set(key, {
            data: result,
            timestamp: Date.now()
          });
        }
        
        return result;
      } catch (error) {
        // 如果请求失败，尝试使用缓存数据（即使已过期）
        const cached = globalCache.get(cacheKey.current);
        if (cached) {
          return cached.data;
        }
        return [];
      }
    },
    {
      refreshDeps: [queryArgs],
      debounceWait: 300, // 增加防抖时间
      ready: queryArgs?.policy_title || queryArgs?.policy_id,
      // 添加缓存配置
      cacheKey: cacheKey.current,
      staleTime: cacheTimeout,
      cacheTime: cacheTimeout
    },
  );
  
  const setQuery = (params) => {
    setQueryArgs((oldValues) => {
      return {
        ...oldValues,
        ...params,
      };
    });
  };

  return {
    loading,
    data: data?.time_line ?? data?.policy_item_list ?? [],
    setQuery
  }
}

export default useGetPolicyTimeline